export const API = process.env.REACT_APP_BACKEND_URL;

export const api = (path, opts = {}) => fetch(`${API}${path}`, {
  credentials: "include",
  ...opts,
  headers: { ...(opts.body ? { "Content-Type": "application/json" } : {}), ...(opts.headers || {}) },
});

export const postJson = (path, body) => api(path, { method: "POST", body: JSON.stringify(body) });

export function errText(data) {
  const d = data && data.detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => (e && e.msg) || "").filter(Boolean).join(" ") || "Please check what you entered.";
  if (typeof d.message === "string") return d.message;
  return "Something went wrong. Please try again.";
}
